import { FieldArray } from 'formik';
import { FormField } from './FormField';
import { PreviewState } from '../ecardsPreact.constants/previewState';
import { RemoveIcon } from '../ecardsPreact.icons/RemoveIcon';
import { useContext } from 'preact/hooks';
import { ECardGlobalState } from './ECardGlobalState';

export default function RecipientFields(props) {
    const { recipients, handleChange, setPreviewState } = props;

    const { selectedRecipient, maxRecipientsVisible } = useContext(ECardGlobalState);

    const handleOnChange = (e) => {
        handleChange(e);
        setPreviewState(PreviewState.Back);
    };

    const handleSetSelectedRecipient = (e, index) => {
        if (e.target.nodeName === 'INPUT') {
            selectedRecipient.set(index);
        }
    };

    const recipientsCount = recipients.length ?? 0;
    const recipientsToShow = recipientsCount > 0 ? (maxRecipientsVisible.get !== -1 ? recipients.slice(0, maxRecipientsVisible.get) : recipients) : null;

    if (recipientsToShow === null) {
        return null;
    } else {
        return (
            <FieldArray
                class=""
                name="EcardMessageDetails.Recipients"
                render={(arrayHelpers) => (
                    <ul class="recipient-list" is="recipient-list">
                        {recipientsToShow.map((recipient, index) => (
                            <li
                                key={index}
                                class={`recipient-list__item recipient-field${recipientsCount > 1 ? ' recipient-field--removable' : ''}`}
                                onClick={(e) => {
                                    handleSetSelectedRecipient(e, index);
                                }}
                            >
                                <FormField
                                    type="text"
                                    wrapperClass="recipient-field__name"
                                    name={`EcardMessageDetails.Recipients.${index}.Name`}
                                    label="Recipient name"
                                    placeholder="Enter recipients name&hellip;"
                                    required
                                    onChange={handleOnChange}
                                />
                                <FormField
                                    type="email"
                                    wrapperClass="recipient-field__email"
                                    name={`EcardMessageDetails.Recipients.${index}.Email`}
                                    label="Recipient email"
                                    placeholder="Enter recipients email&hellip;"
                                    required
                                    onChange={handleOnChange}
                                />

                                {recipientsCount > 1 && (
                                    <button
                                        class="button-reset remove-button recipient-field__remove"
                                        type="button"
                                        onClick={() => {
                                            const currentSelectedIndex = selectedRecipient.get;

                                            if (currentSelectedIndex >= index && currentSelectedIndex > 0) {
                                                selectedRecipient.set(currentSelectedIndex - 1);
                                            }

                                            arrayHelpers.remove(index);
                                        }}
                                    >
                                        <span class="md:sr-only lg:not-sr-only xl:sr-only">Remove above recipient</span>
                                        <RemoveIcon />
                                    </button>
                                )}
                            </li>
                        ))}
                    </ul>
                )}
            ></FieldArray>
        );
    }
}
